import _ from 'lodash';
import { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import appFormatLang from '../langs/appFormatLang';
import getSymbolFromCurrency from 'currency-symbol-map';
import { TInvestFundCurrency } from '../../../../apps/investor/types/fund/TInvestFundCurrency';
const useAppFormatAmount = () => {
	const { t } = useTranslation();

	const displayRounding = (amount: number, rounding: string) => {
		let round = 2;
		const roundMax = 8;
		let result = 0;
		while (result === 0 && round <= roundMax) {
			switch (rounding) {
				case 'b':
					result = _.round(amount / 1000000000, round);
					break;
				case 'm':
					result = _.round(amount / 1000000, round);
					break;
				case 'k':
					result = _.round(amount / 1000, round);
					break;
				default:
					result = _.round(amount, round);
			}
			round += 1;
		}
		return result;
	};

	const displayRoundingSuffix = useCallback(
		(rounding: string) => {
			switch (rounding) {
				case 'b':
					return t(appFormatLang.billion_prefix.tag);
				case 'm':
					return t(appFormatLang.million_prefix.tag);
				case 'k':
					return t(appFormatLang.kilo_prefix.tag);
				default:
					return '';
			}
		},
		[t],
	);

	const displayCurrencySymbol = useCallback((currency?: TInvestFundCurrency) => {
		if (currency) {
			return getSymbolFromCurrency(currency);
		}
		return '';
	}, []);

	return useMemo(
		() => ({
			displayRounding,
			displayRoundingSuffix,
			displayCurrencySymbol,
		}),
		[displayCurrencySymbol, displayRoundingSuffix],
	);
};

export default useAppFormatAmount;
